import { render } from "./VehicleEntry.vue?vue&type=template&id=6ff68ac0"
import script from "./VehicleEntry.vue?vue&type=script&lang=js"
export * from "./VehicleEntry.vue?vue&type=script&lang=js"

import "./VehicleEntry.vue?vue&type=style&index=0&id=6ff68ac0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__